import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listCollection, type Row } from '../../lib/db';

export function BlogList() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);
  const [onlyReview, setOnlyReview] = useState(false);

  useEffect(() => {
    listCollection('blogPosts', 'createdAt').then((r) => {
      setRows(r);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">Interview stories</h3>
        <Link to="/interviews/new" className="btn btn-success btn-sm">
          New story
        </Link>
      </div>
      <div className="form-check mb-3">
        <input className="form-check-input" type="checkbox" id="onlyReview" checked={onlyReview} onChange={(e) => setOnlyReview(e.target.checked)} />
        <label className="form-check-label" htmlFor="onlyReview">
          Show only stories needing review ({rows.filter((r) => r.needsReview).length})
        </label>
      </div>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Title (BG)</th>
              <th>Slug</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.filter((r) => !onlyReview || r.needsReview).map((r) => {
              const title = (r.title ?? {}) as { bg?: string; en?: string };
              return (
                <tr key={r.id}>
                  <td>{title.bg || title.en || '—'}</td>
                  <td className="small text-muted">{String(r.slug ?? '')}</td>
                  <td>
                    <span className={`badge bg-${r.status === 'published' ? 'success' : 'secondary'}`}>
                      {String(r.status ?? '')}
                    </span>
                    {r.needsReview ? <span className="badge bg-warning text-dark ms-1">review</span> : null}
                    {r.anonymised ? <span className="badge bg-info text-dark ms-1">anonymised</span> : null}
                  </td>
                  <td className="text-end">
                    <Link
                      to={`/interviews/${r.slug || r.id}`}
                      className="btn btn-sm btn-outline-secondary"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
